import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { seo } from '../config/seo';

/** Updates canonical + og:url when the SPA route changes (config.js only runs once). */
const HeadRouteSync = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const base =
      typeof window !== 'undefined' && process.env.NODE_ENV === 'development'
        ? window.location.origin.replace(/\/$/, '')
        : seo.siteUrl.replace(/\/$/, '');
    const path = pathname === '/' || pathname === '' ? '/' : pathname.startsWith('/') ? pathname : `/${pathname}`;
    const url = path === '/' ? `${base}/` : `${base}${path}`;

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', url);

    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) ogUrl.setAttribute('content', url);
  }, [pathname]);

  return null;
};

export default HeadRouteSync;
